/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useMemo, useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import Fab from "@mui/material/Fab";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React themes
import theme from "assets/theme";
import Presentation from "layouts/pages/presentation";
import Privacy from "pages/LandingPages/Privacy";

// Material Kit 2 React routes
import routes from "routes";

export default function App() {
  const { pathname } = useLocation();
  const [darkMode, setDarkMode] = useState(false);

  const themeWithDarkMode = useMemo(() => {
    const updatedTheme = createTheme({
      ...theme,
      palette: {
        ...theme.palette,
        mode: darkMode ? "dark" : "light",
        ...(darkMode
          ? {
              background: {
                default: "#1a2035",
                paper: "#1a2035",
              },
              text: {
                primary: "#ffffff",
              },
            }
          : {}),
      },
    });
    return updatedTheme;
  }, [darkMode]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={themeWithDarkMode}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        <Route path="/presentation" element={<Presentation />} />
        <Route path="/pages/landing-pages/privacy" element={<Privacy />} />
        <Route path="*" element={<Navigate to="/presentation" />} />
      </Routes>
      <MKBox position="fixed" bottom="2rem" right="2rem" zIndex={99}>
        <Fab color="info" aria-label="toggle theme" onClick={() => setDarkMode(!darkMode)}>
          <Icon>{darkMode ? "light_mode" : "dark_mode"}</Icon>
        </Fab>
      </MKBox>
    </ThemeProvider>
  );
}
